import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import classes from "./SignInPage.module.scss";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { postAxios } from "api/Axios";
import { resetEmailApi, confirmResetEmailApi } from "api/Urls";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import {
  validPassword,
  validNumber,
  validOneUpperCase,
  validOneDot,
  validEightCharacter,
} from "util/Regexes";

const ForgotPassOne = ({ isForgotPass, setIsForgotPass }) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t, i18n } = useTranslation();
  const [inputValues, setInputValues] = useState({
    forgotEmail: "",
    newPassword: "",
    resetCode: "",
  });
  const [isEnterEmail, setIsEnterEmail] = useState(false);
  const [codeLoader, setCodeLoader] = useState(false);
  const [emailLoader, setEmailLoader] = useState(false);
  const [passwordValidation, setPasswordValidation] = useState(false);

  const changeHandler = (e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputValues({ ...inputValues, [name]: value });
    if (name === "newPassword") {
      setPasswordValidation(validPassword.test(value));
    }
  };

  const emailClickHandler = () => {
    setEmailLoader(true);
    let finalData = new FormData();
    finalData.append("email", inputValues.forgotEmail);
    postAxios(`${resetEmailApi}`, finalData)
      .then((data) => {
        if (data.status === 200) {
          setIsEnterEmail(true);
          setEmailLoader(false);
        }
      })
      .catch((err) => {
        setEmailLoader(false);
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
      });
  };

  const codeClickHandler = () => {
    setCodeLoader(true);
    let finalData = new FormData();
    finalData.append("email", inputValues.forgotEmail);
    finalData.append("password", inputValues.newPassword);
    finalData.append("code", inputValues.resetCode);
    postAxios(`${confirmResetEmailApi}`, finalData)
      .then((data) => {
        if (data.status === 200) {
          setIsForgotPass(false);
          setIsEnterEmail(false);
          setCodeLoader(false);
        }
      })
      .catch((err) => {
        setCodeLoader(false);
        if (err?.response) {
          enqueueSnackbar(err.response.data.message, {
            variant: "error",
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            style: { direction: i18n.language === "en" ? "ltr" : "rtl" },
          });
        } else {
          console.log(err);
        }
      });
  };

  const handleDecreaseSteps = () => {
    if (isForgotPass && !isEnterEmail) {
      setIsForgotPass(false);
    } else {
      setIsEnterEmail(false);
    }
  };

  return (
    <>
      <div className="app-login-header mb-4">
        <h1>{t("sign_in.forgot_password_title")}</h1>
      </div>
      <div className={classes.buttonRootSecondary}>
        <Button
          variant="contained"
          className="btn btn-primary jr-btn-uptin"
          onClick={() => {
            handleDecreaseSteps();
          }}
          color="primary"
        >
          {isEnterEmail
            ? t("sign_up.sign_up_back_step_button")
            : t("sign_in.sign_up_login_step_button")}
          <ArrowBackIcon style={{ fontSize: "1rem" }} />
        </Button>
      </div>

      {isEnterEmail ? (
        <div className="app-login-form">
          <form>
            <fieldset>
              <span className={classes.inputRoot}>
                <div className={classes.forgot_pass}>
                  <p>{t("sign_in.forgot_password_desc_2")}</p>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      onInput={(e) => {
                        e.target.value = Math.max(0, parseInt(e.target.value))
                          .toString()
                          .slice(0, 6);
                      }}
                      type="number"
                      name="resetCode"
                      id="outlined-adornment-weight"
                      onChange={changeHandler}
                      defaultValue={inputValues.resetCode}
                      startAdornment={
                        i18n.language === "fa" && (
                          <InputAdornment
                            position="start"
                            disablePointerEvents={true}
                          >
                            {t("sign_in.forgot_password_code")}
                          </InputAdornment>
                        )
                      }
                      endAdornment={
                        i18n.language === "en" && (
                          <InputAdornment
                            position="end"
                            disablePointerEvents={true}
                          >
                            {t("sign_in.forgot_password_code")}
                          </InputAdornment>
                        )
                      }
                    />
                  </FormControl>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      type="password"
                      name="newPassword"
                      id="outlined-adornment-weight"
                      onChange={changeHandler}
                      defaultValue={inputValues.newPassword}
                      autoComplete="new-password"
                      error={inputValues.newPassword && !passwordValidation}
                      startAdornment={
                        i18n.language === "fa" && (
                          <InputAdornment
                            position="start"
                            disablePointerEvents={true}
                          >
                            {t("sign_in.forgot_password_pass")}
                          </InputAdornment>
                        )
                      }
                      endAdornment={
                        i18n.language === "en" && (
                          <InputAdornment
                            position="end"
                            disablePointerEvents={true}
                          >
                            {t("sign_in.forgot_password_pass")}
                          </InputAdornment>
                        )
                      }
                    />
                  </FormControl>
                </div>
              </span>
              {/* Password hints */}
              <div
                className={
                  i18n.language === "en"
                    ? classes.passHint
                    : classes.passHintRtl
                }
              >
                <p>{t("sign_up.password_must")}</p>
                <p
                  className={
                    validEightCharacter.test(inputValues.newPassword)
                      ? classes.correctRegex
                      : ""
                  }
                >
                  {t("sign_up.eight_character")}
                </p>
                <p
                  className={
                    validOneUpperCase.test(inputValues.newPassword)
                      ? classes.correctRegex
                      : ""
                  }
                >
                  {t("sign_up.include_capital_letter")}
                </p>
                <p
                  className={
                    validNumber.test(inputValues.newPassword)
                      ? classes.correctRegex
                      : ""
                  }
                >
                  {t("sign_up.include_numbers")}
                </p>
                <p
                  className={
                    validOneDot.test(inputValues.newPassword)
                      ? classes.correctRegex
                      : ""
                  }
                >
                  {t("sign_up.and_include_spacial_character")}
                </p>
              </div>
              <div className="mb-3 d-flex flex-column align-items-center justify-content-between">
                <span className={classes.buttonRoot}>
                  <Button
                    className="btn btn-primary jr-btn-uptin"
                    onClick={codeClickHandler}
                    variant="contained"
                    disabled={
                      !inputValues.resetCode ||
                      !inputValues.forgotEmail ||
                      !passwordValidation
                    }
                  >
                    {codeLoader ? (
                      <CircularProgress size={20} color="secondary" />
                    ) : (
                      t("sign_in.forgot_password_ok")
                    )}
                  </Button>
                </span>
              </div>
            </fieldset>
          </form>
        </div>
      ) : (
        <div
          className="app-login-form"
          style={{
            maxWidth: "300px",
            width: "100%",
          }}
        >
          <form>
            <fieldset>
              <span className={classes.inputRoot}>
                <div className={classes.forgot_pass}>
                  <p>{t("sign_in.forgot_password_desc")}</p>
                </div>
                <div className={classes.outlinedInput}>
                  <FormControl variant="outlined">
                    <OutlinedInput
                      id="outlined-adornment-weight"
                      name="forgotEmail"
                      onChange={(e) => changeHandler(e)}
                      defaultValue={inputValues.forgotEmail}
                      value={inputValues.forgotEmail}
                      startAdornment={
                        i18n.language === "fa" && (
                          <InputAdornment
                            position="start"
                            disablePointerEvents={true}
                          >
                            {t("sign_in.email")}
                          </InputAdornment>
                        )
                      }
                      endAdornment={
                        i18n.language === "en" && (
                          <InputAdornment
                            position="end"
                            disablePointerEvents={true}
                          >
                            {t("sign_in.email")}
                          </InputAdornment>
                        )
                      }
                    />
                  </FormControl>
                </div>
              </span>

              <div className="mb-3 d-flex flex-column align-items-center justify-content-between">
                <span className={classes.buttonRoot}>
                  <Button
                    className="btn btn-primary jr-btn-uptin"
                    onClick={emailClickHandler}
                    variant="contained"
                    disabled={!inputValues.forgotEmail}
                  >
                    {emailLoader ? (
                      <CircularProgress size={20} color="secondary" />
                    ) : (
                      t("sign_in.forgot_password_2")
                    )}
                  </Button>
                </span>
              </div>
            </fieldset>
          </form>
        </div>
      )}
    </>
  );
};

export default ForgotPassOne;
